module.exports = __webpack_public_path__ + "img/directex-arrow-right.1b9c6a68.svg";